import { render, staticRenderFns } from "./MyAccreditationPassForm.vue?vue&type=template&id=3828cca4&scoped=true"
import script from "./MyAccreditationPassForm.vue?vue&type=script&lang=js"
export * from "./MyAccreditationPassForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3828cca4",
  null
  
)

export default component.exports